import React, { useEffect, useState } from 'react';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import AuthTenantNoData from '../../../error/AuthTenantNoData';
import { Block, BlockBetween, BlockHead, BlockHeadContent, Button, Col, DataTableBody, DataTableHead, DataTableItem, DataTableRow, Icon, Row } from '../../../../components/Component';
import CardTabs from '../../../components/cards/CardTabs';
import { useDispatch } from 'react-redux';
import { RETRIEVE_TENANT_PRODUCTS_ANALYTICS_API } from '../../../../api/api_data';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_tenant_product_analytics, loading_retrieve_tenant_product_analytics, reset_retrieve_tenant_product_analytics, success_retrieve_tenant_product_analytics } from '../../../../reducers/auth_tenant/retrieve_tenant_product_analytics_Slice';
import { RETRIEVE_TENANT_PRODUCT_ANALYTICS_ERROR_MSG, RETRIEVE_TENANT_PRODUCT_ANALYTICS_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { addThreeDots, formatToSentenceCase, joinWithCommas, messageToast } from '../../../../utils/Utils';
import * as app_consts from "../../../../utils/app_consts";
import { Link } from 'react-router-dom';
import { Badge, Card } from 'reactstrap';
import { Pie } from 'react-chartjs-2';

import { Chart, CategoryScale, LinearScale, BarElement, PointElement, LineElement, ArcElement, Tooltip, Filler, Legend, } from "chart.js";

Chart.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, ArcElement, Tooltip, Filler, Legend,);

const ProductsAnalyticalData = ({ tenant_info, user_info }) => {

 const [loading, setLoading] = useState(true);
 const [error, setError] = useState("");
 const [page_data, setPageData] = useState();
 const [status_labels, setStatusLabels] = useState([]);
 const [status_values, setStatusValues] = useState([]);

 const dispatch = useDispatch();

 useEffect(() => {
  retrive_product_analytics();
 }, []);

 const retrive_product_analytics = () => {
  setError("");
  setLoading(true);
  dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_product_analytics, success_retrieve_tenant_product_analytics, fail_retrieve_tenant_product_analytics, RETRIEVE_TENANT_PRODUCT_ANALYTICS_ERROR_MSG, RETRIEVE_TENANT_PRODUCT_ANALYTICS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_PRODUCTS_ANALYTICS_API}`));
 };

 // Listen
 const retrieve_tenant_product_analytics_listener = useSelector((state) => state.retrieve_tenant_product_analytics.retrieve_tenant_product_analytics);

 useEffect(() => {
  if (retrieve_tenant_product_analytics_listener.status !== app_consts.IDLE)
  {
   if (retrieve_tenant_product_analytics_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    if (retrieve_tenant_product_analytics_listener.status === app_consts.FAIL)
    {
     setLoading(false);
     setError(retrieve_tenant_product_analytics_listener.message);
     messageToast(retrieve_tenant_product_analytics_listener.message, app_consts.FAIL);
    } else if (retrieve_tenant_product_analytics_listener.status === app_consts.SUCCESS)
    {
     setPageData(retrieve_tenant_product_analytics_listener.data);
     setStatusLabels(retrieve_tenant_product_analytics_listener.data?.status_count?.map((stat) => formatToSentenceCase(stat?.label)));
     setStatusValues(retrieve_tenant_product_analytics_listener.data?.status_count?.map((stat) => stat?.value));

     const timer = setTimeout(() => {
      setLoading(false);
     }, 1000);

     return () => clearTimeout(timer); // cleanup in case the component unmounts
    }
    dispatch(reset_retrieve_tenant_product_analytics());
   }
  }
 }, [retrieve_tenant_product_analytics_listener]);

 const status_piechart_data = {
  labels: status_labels,
  datasets: [{
   data: status_values,
   backgroundColor: ["#6576ff", "#e3e7fe", "#8e9dff", "#b1bcff", "#d0d7ff"],
   borderWidth: 0
  }]
 };

 const pieOptions = {
  plugins: {
   legend: {
    position: 'bottom',
    labels: {
     usePointStyle: true,
     padding: 20,
     font: {
      family: "'Inter', sans-serif",
      size: 12
     }
    }
   },
   tooltip: {
    callbacks: {
     label: function (context) {
      const label = context.label || '';
      const value = context.raw || 0;
      const total = context.dataset.data.reduce((a, b) => a + b, 0);
      const percentage = Math.round((value / total) * 100);
      return `${label}: ${value} (${percentage}%)`;
     }
    }
   }
  },
  cutout: '70%',
  maintainAspectRatio: false
 };

 return (
  <div style={{ padding: '0 15px' }} className='mt-4'>
   <BlockHead size="sm">
    <BlockHeadContent style={{ marginBottom: '20px' }}>
     <h4 style={{ marginBottom: '5px', fontWeight: '600', color: '#1a1a1a' }}>Product Analytics</h4>
    </BlockHeadContent>
    {!loading && (
     <div style={{ marginTop: '8px' }}>
      <Link onClick={(e) => { e.preventDefault(); retrive_product_analytics(); }}>
       <Button color="light" outline style={{ backgroundColor: 'white', display: 'inline-flex', alignItems: 'center' }}>
        <span>Refresh</span>
       </Button>
      </Link>
     </div>
    )}
   </BlockHead>

   {loading ? (
    <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Product Analytics..." />
   ) : error ? (
    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
   ) : (
    <Block style={{ marginTop: '20px' }}>
     <Row className="g-gs" style={{ marginBottom: '20px' }}>
      {/* Stats Cards */}
      <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
       <Card style={{
        borderRadius: '8px',
        border: '1px solid #e5e9f2',
        transition: 'all 0.3s ease',
        marginBottom: 0,
        height: '100%',
        ':hover': {
         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
         transform: 'translateY(-2px)'
        }
       }}>
        <div style={{ padding: '20px' }}>
         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
           <h6 style={{ fontSize: '14px', color: '#6c757d', marginBottom: '8px' }}>Total Products</h6>
           <h2 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>{page_data?.no_of_products || "0"}</h2>
          </div>
          <div style={{
           width: '48px',
           height: '48px',
           borderRadius: '50%',
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center',
           fontSize: '24px',
           backgroundColor: 'rgba(101, 118, 255, 0.1)'
          }}>
           <Icon name="box" style={{ color: '#6576ff' }}></Icon>
          </div>
         </div>
        </div>
       </Card>
      </Col>

      <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
       <Card style={{
        borderRadius: '8px',
        border: '1px solid #e5e9f2',
        transition: 'all 0.3s ease',
        marginBottom: 0,
        height: '100%',
        ':hover': {
         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
         transform: 'translateY(-2px)'
        }
       }}>
        <div style={{ padding: '20px' }}>
         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
           <h6 style={{ fontSize: '14px', color: '#6c757d', marginBottom: '8px' }}>Brands</h6>
           <h2 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>{page_data?.brand_count?.length || "0"}</h2>
          </div>
          <div style={{
           width: '48px',
           height: '48px',
           borderRadius: '50%',
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center',
           fontSize: '24px',
           backgroundColor: 'rgba(25, 162, 255, 0.1)'
          }}>
           <Icon name="tag" style={{ color: '#19a2ff' }}></Icon>
          </div>
         </div>
        </div>
       </Card>
      </Col>

      <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
       <Card style={{
        borderRadius: '8px',
        border: '1px solid #e5e9f2',
        transition: 'all 0.3s ease',
        marginBottom: 0,
        height: '100%',
        ':hover': {
         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
         transform: 'translateY(-2px)'
        }
       }}>
        <div style={{ padding: '20px' }}>
         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
           <h6 style={{ fontSize: '14px', color: '#6c757d', marginBottom: '8px' }}>Product Types</h6>
           <h2 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>{page_data?.product_type_count?.length || "0"}</h2>
          </div>
          <div style={{
           width: '48px',
           height: '48px',
           borderRadius: '50%',
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center',
           fontSize: '24px',
           backgroundColor: 'rgba(239, 87, 119, 0.1)'
          }}>
           <Icon name="layers" style={{ color: '#ef5777' }}></Icon>
          </div>
         </div>
        </div>
       </Card>
      </Col>

      <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
       <Card style={{
        borderRadius: '8px',
        border: '1px solid #e5e9f2',
        transition: 'all 0.3s ease',
        marginBottom: 0,
        height: '100%',
        ':hover': {
         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
         transform: 'translateY(-2px)'
        }
       }}>
        <div style={{ padding: '20px' }}>
         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
           <h6 style={{ fontSize: '14px', color: '#6c757d', marginBottom: '8px' }}>Products with SKUs</h6>
           <h2 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>{page_data?.products_with_skus || "0"}</h2>
          </div>
          <div style={{
           width: '48px',
           height: '48px',
           borderRadius: '50%',
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center',
           fontSize: '24px',
           backgroundColor: 'rgba(136, 108, 255, 0.1)'
          }}>
           <Icon name="file-text" style={{ color: '#886cff' }}></Icon>
          </div>
         </div>
        </div>
       </Card>
      </Col>

      {/* Status Pie Chart */}
      <Col xxl="3" md="6" style={{ marginBottom: '20px' }}>
       <Card style={{
        borderRadius: '8px',
        border: '1px solid #e5e9f2',
        height: '100%',
        overflow: 'hidden'
       }}>
        <div style={{ padding: '20px' }}>
         <div style={{ marginBottom: '16px' }}>
          <h6 style={{ fontSize: '16px', fontWeight: '500', margin: 0 }}>Product Status Distribution</h6>
         </div>
         <div style={{ height: '200px', position: 'relative', marginBottom: '16px' }}>
          <Pie data={status_piechart_data} options={pieOptions} />
         </div>
         <div style={{ marginTop: '12px' }}>
          {page_data?.status_count?.map((stat, index) => (
           <div key={index} style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px',
            fontSize: '14px'
           }}>
            <span style={{
             width: '10px',
             height: '10px',
             borderRadius: '50%',
             marginRight: '8px',
             backgroundColor: status_piechart_data.datasets[0].backgroundColor[index]
            }}></span>
            <span style={{ flex: 1 }}>{formatToSentenceCase(stat?.label) || "--"}</span>
            <span style={{ fontWeight: '500' }}>{stat?.value || 0}</span>
           </div>
          ))}
         </div>
        </div>
       </Card>
      </Col>

      {/* Recent Products Table */}
      <Col xxl="9" style={{ marginBottom: '20px' }}>
       <Card style={{
        borderRadius: '8px',
        border: '1px solid #e5e9f2'
       }}>
        <div style={{ padding: '20px', borderBottom: '1px solid #e5e9f2' }}>
         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
           <h6 style={{ fontSize: '16px', fontWeight: '500', margin: 0 }}>Recent Products</h6>
          </div>
          <div>
           <Link to={`/${tenant_info.url_prefix}/products_management`} style={{
            color: '#6576ff',
            textDecoration: 'none',
            fontWeight: '500',
            ':hover': {
             textDecoration: 'underline'
            }
           }}>
            View All
           </Link>
          </div>
         </div>
        </div>
        <div style={{ padding: '20px' }}>
         <div className="nk-tb-list">
          <DataTableBody>
           <DataTableHead>
            <DataTableRow size="sm">
             <span>Brand</span>
            </DataTableRow>
            <DataTableRow>
             <span>Product</span>
            </DataTableRow>
            <DataTableRow>
             <span>Type</span>
            </DataTableRow>
            <DataTableRow>
             <span>SKU</span>
            </DataTableRow>
            <DataTableRow>
             <span>Stock</span>
            </DataTableRow>
            <DataTableRow size="md">
             <span>Sizes</span>
            </DataTableRow>
            <DataTableRow size="md">
             <span>Status</span>
            </DataTableRow>
            <DataTableRow size="md">
             <span>Action</span>
            </DataTableRow>
           </DataTableHead>
           {page_data?.recent_products ? (
            page_data?.recent_products?.map((item, idx) => (
             <DataTableItem key={item.id}>
              <DataTableRow size="sm">
               <Link to={`/${tenant_info.url_prefix}/products_management/${item?.id}`} style={{ color: '#1a1a1a', textDecoration: 'none' }}>
                <span className="tb-product">
                 <span className="title">{item.category || "--"}</span>
                </span>
               </Link>
              </DataTableRow>
              <DataTableRow>
               <span className="tb-product" style={{ display: 'flex', alignItems: 'center' }}>
                <img
                 src={item.product_img || "https://via.placeholder.com/40"}
                 alt="product"
                 style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '4px',
                  objectFit: 'cover',
                  marginRight: '10px'
                 }}
                 onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://via.placeholder.com/40";
                 }}
                />
                <span className="tb-sub">{item?.name || "--"}</span>
               </span>
              </DataTableRow>
              <DataTableRow>
               <span className="tb-sub">{item?.product_type || "--"}</span>
              </DataTableRow>
              <DataTableRow>
               <span className="tb-sub">{item?.sku_no || "--"}</span>
              </DataTableRow>
              <DataTableRow>
               <span className="tb-sub">{item?.total_stock || "0"}</span>
              </DataTableRow>
              <DataTableRow size="md">
               <span className="tb-sub">
                {item?.packet_sizes ? addThreeDots(joinWithCommas(item?.packet_sizes), 30) : "--"}
               </span>
              </DataTableRow>
              <DataTableRow size="md">
               <Badge
                color={item?.status === app_consts.ACTIVE ? "success" : "danger"}
                pill
                style={{
                 padding: '4px 8px',
                 fontSize: '11px',
                 fontWeight: '500'
                }}
               >
                {item?.status?.toUpperCase() || "--"}
               </Badge>
              </DataTableRow>
              <DataTableRow className="nk-tb-col-tools">
               <Link to={`/${tenant_info.url_prefix}/products_management/${item?.id}`}>
                <Button color="light" outline size="sm" style={{
                 display: 'inline-flex',
                 alignItems: 'center',
                 padding: '4px 8px'
                }}>
                 <Icon name="eye" style={{ marginRight: '4px' }}></Icon>
                 <span>View</span>
                </Button>
               </Link>
              </DataTableRow>
             </DataTableItem>
            ))
           ) : (
            <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Products Found"} />
           )}
          </DataTableBody>
         </div>
        </div>
       </Card>
      </Col>
     </Row>
    </Block>
   )}
  </div>
 );
};

export default ProductsAnalyticalData;